import gql from 'graphql-tag';

export const GET_DOBLE_FACTOR_USER_TYPES = gql(`
    query($userId: Int) {
        usuarioDobleAutenticacionQuery {
            getDobleFactorUserCode(usuarioId:$userId) {
                codigo
                usuarioId
            }
        }
    }
`);

export const SET_DOBLE_FACTOR_USER_CODE = gql(`
    query($userId: Int, $dobleFactorType: String!) {
        usuarioDobleAutenticacionQuery {
            setDobleFactorUserCode(usuarioId:$userId, dobleFactorType:$dobleFactorType) {
                usuarioId,
                codigo,
                fechaCaducidadCodigo,
                fechaCaducidadDobleAuth,
                validado
            }
        }
    }
`);

export const CONFIRM_DOBLE_FACTOR_USER = gql(`
    query($userId: Int) {
        usuarioDobleAutenticacionQuery {
            confirmDobleFactorUser(usuarioId:$userId) {
                usuarioId,
                codigo,
                fechaCaducidadCodigo,
                fechaCaducidadDobleAuth,
                validado
            }
        }
    }
`);